export const SET_DEBUG = 'SET_DEBUG';

export const setDebug = (isDebug) => ({
  type: SET_DEBUG,
  payload: isDebug
})